<form (submit)="handleOnSubmit($event)" [formGroup]="configForm">
  <h2 mat-dialog-title>{{ title || 'CONFIGURATION' | translate }}</h2>

  <div mat-dialog-content class="dialog-content">
    <!-- <sc-ocpp201-component-list
    [listenChanges]="true"
    [showControllerInput]="showControllerInput"
    [showVariableInput]="showVariableInput"
    [showValueInput]="showValueInput"
    [showAttributeTypeInput]="showAttributeTypeInput"
    [showInstanceInput]="showInstanceInput"
    [showESVEIDInput]="showESVEIDInput"
    (onListChange)="onListChange($event)"
  [useDialogSubmit]="true"></sc-ocpp201-component-list> -->

  @if (showComponentCriteria) {
    <div>
      <mat-form-field>
        <mat-label>Component criterion</mat-label>
        <mat-select formControlName="ComponentCriteria" multiple>
          <mat-select-trigger>
            {{ configForm.controls.ComponentCriteria.value?.join(',') || '' }}
          </mat-select-trigger>
          @for (item of ComponentCriteriaList; track item) {
            <mat-option [value]="item">
              {{ item }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }

  <div formArrayName="Configurations">
    @for (item of Configurations.controls; track item; let i = $index) {
      <div class="mb-4 flex" [formGroupName]="i">
        @if (ocppVersion === ocppEnum.VERSION_201_JSON || ocppVersion === ocppEnum.VERSION_21_JSON) {
          @if (!hideControllerInput) {
            <mat-form-field floatLabel="auto">
              <mat-label>Controller</mat-label>
              <input
                type="text"
                matInput
                (focus)="filterComponents($event)"
                (input)="filterComponents($event)"
                formControlName="Controller"
                [matAutocomplete]="autoComponents" />
              <mat-autocomplete #autoComponents="matAutocomplete">
                @for (item of componentsList; track item) {
                  <mat-option [value]="item">
                    {{ item }}
                  </mat-option>
                }
              </mat-autocomplete>
              <mat-error>{{ 'REQUIRED' | translate }}</mat-error>
            </mat-form-field>
          }
          @if (!hideVariableInput) {
            <mat-form-field floatLabel="auto" class="ml-4">
              <mat-label>Key</mat-label>
              <input
                type="text"
                matInput
                (focus)="filteVariable($event)"
                (input)="filteVariable($event)"
                formControlName="Key"
                [matAutocomplete]="autoVariables" />
              <mat-autocomplete #autoVariables="matAutocomplete">
                @for (item of variablesList; track item) {
                  <mat-option [value]="item">
                    {{ item }}
                  </mat-option>
                }
              </mat-autocomplete>
              <mat-error>{{ 'REQUIRED' | translate }}</mat-error>
            </mat-form-field>
          }
          @if (!hideValueInput) {
            <mat-form-field floatLabel="auto" class="ml-4">
              <mat-label>Value</mat-label>
              <input matInput required formControlName="Value" />
              <mat-error>{{ 'REQUIRED' | translate }}</mat-error>
            </mat-form-field>
          }
          @if (!hideAttributeTypeInput) {
            <mat-form-field floatLabel="auto" class="ml-4">
              <mat-label>Attribute Type</mat-label>
              <mat-select formControlName="AttributeType">
                <mat-option></mat-option>
                <mat-option value="Actual">Actual</mat-option>
                <mat-option value="Target">Target</mat-option>
                <mat-option value="MinSet">MinSet</mat-option>
                <mat-option value="MaxSet">MaxSet</mat-option>
              </mat-select>
            </mat-form-field>
          }
          @if (!hideInstanceInput) {
            <mat-form-field floatLabel="auto" class="ml-4">
              <mat-label>Instance</mat-label>
              <input matInput formControlName="Instance" />
            </mat-form-field>
          }
          @if (!hideESVEIDInput) {
            <mat-form-field floatLabel="auto" class="ml-4">
              <mat-label>EVSE ID</mat-label>
              <input matInput formControlName="EVSEID" type="number" />
            </mat-form-field>
          }
        }
        @if (ocppVersion === ocppEnum.VERSION_16_JSON) {
          <mat-form-field floatLabel="auto">
            <mat-label>Key</mat-label>
            <input matInput required formControlName="Key" />
            <mat-error>{{ 'REQUIRED' | translate }}</mat-error>
          </mat-form-field>
          @if (!hideValueInput) {
            <mat-form-field floatLabel="auto" class="ml-4">
              <mat-label>Value</mat-label>
              <input matInput required formControlName="Value" />
              <mat-error>{{ 'REQUIRED' | translate }}</mat-error>
            </mat-form-field>
          }
        }
        @if (Configurations.length > 1) {
          <button mat-icon-button class="ml-4" (click)="deleteComponentValue(i)">
            <mat-icon>delete</mat-icon>
          </button>
        }
      </div>
    }
  </div>

  <div class="mb-4">
    <button mat-raised-button (click)="addComponentValue()">
      <mat-icon>add</mat-icon>
      {{ 'ADD' | translate }}
    </button>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" type="submit">
    {{ action || ('OK' | translate) }}
  </button>
  <button mat-raised-button (click)="close()" type="button">
    {{ 'CANCEL' | translate }}
  </button>
</div>
</form>
